import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Padding } from '../UI/index'
import _ from 'lodash'

import Modal from 'react-bootstrap-modal'
import DOMPurify from 'dompurify'

export default class ViewContentNotesModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object,
    data: PropTypes.object
  }
  constructor(props) {
    super(props)
    this.state = {
      openNotification: false
    }
  }

  render() {
    const { isOpen, onClose } = this.props

    return !!this.props.data ? (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="event-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <Padding size="24px">
            <h1>{this.props.data.title}</h1>
            <hr />
            <div className="form-horizontal create-poi__form-container">
              <div className="content contentNotes" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.data.content) }} />
            </div>
          </Padding>
        </Modal.Body>
      </Modal>
    ) : null
  }
}



// WEBPACK FOOTER //
// src/components/Notes/ViewContentNotesModal.js